export default __webpack_public_path__ + "static/media/pledge-money.a3470f4e.png";